const MAX_LENGTH = 300;

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function capped(text) {
  const trimmed = text.trim();
  return trimmed.length > MAX_LENGTH ? trimmed.slice(0, MAX_LENGTH) : trimmed;
}

// Server text is shown only from a 4xx object body; 5xx bodies from routes not
// yet on typed errors can carry internals, and an Error's own message is
// client-side text.
function messageFromBody(data) {
  if (!isPlainObject(data)) return '';
  if (typeof data.error === 'string' && data.error.trim()) return capped(data.error);
  if (typeof data.message === 'string' && data.message.trim()) return capped(data.message);
  if (Array.isArray(data.details) && data.details.length > 0
    && data.details.every((detail) => typeof detail === 'string')) {
    const joined = data.details.map((detail) => detail.trim()).filter(Boolean).join(', ');
    if (joined) return capped(joined);
  }
  return '';
}

export function formatApiError(value, fallback = '') {
  if (value === null || value === undefined || value === '') {
    return fallback || '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object' && (value.isAxiosError === true || 'response' in value)) {
    const { response } = value;
    if (!response) {
      return fallback || 'Network Error';
    }
    if (response.status >= 500) {
      return fallback || 'Something went wrong. Please try again.';
    }
    return messageFromBody(response.data) || fallback || 'Something went wrong. Please try again.';
  }

  if (value instanceof Error) {
    return fallback || 'Unexpected error';
  }

  return fallback || '';
}
